import { useLocalStore } from "@/context/StateContext";
import Types from "@/types";

export default async function getName(id: string): Promise<{
  id: string
  name: string
  nameId: string
}> {
  const localStore = useLocalStore()
  if (!localStore.database) throw new Error("No database")
  const query = localStore.database.connections.findOne({
    selector: {
      origin: id,
      type: Types.Name
    }
  })
  const queryResult = await query.exec()
  return {
    id,
    name: queryResult.target,
    nameId: queryResult.id
  }
}
